export default "__VITE_ASSET__c0b65769__"